import { routes as execucaoDiretaRotas, routesPerfilGestor as execucaoDiretaRotasPerfilGestor, routesPreFixRelatorio } from './execucaodireta/rotas.js';

const routes = {
    path: 'convenios',
    name: 'Rm_Convenios',
    component: () => import('./Convenios.vue'),
    children: [execucaoDiretaRotas, execucaoDiretaRotasPerfilGestor, routesPreFixRelatorio],
    meta: {
        rules: [...execucaoDiretaRotas.meta.rules, ...execucaoDiretaRotasPerfilGestor.meta.rules, ...routesPreFixRelatorio.meta.rules],
    },
};

export default routes;
